module.exports = __webpack_public_path__ + "img/cardinal.2761928f.png";